export default {
  data() {
    return { windowWidth: window.innerWidth };
  },
  methods: {
    handleWindowResize(event) {
      this.windowWidth = this.getWindowWidth(event);
    },
    getWindowWidth(event) {
      if (event && event.currentTarget) {
        return event.currentTarget.innerWidth;
      }
      if (event && event.target) {
        return event.target.innerWidth;
      }
      return window.innerWidth;
    },
  },
  mounted() {
    this.handleWindowResize();
    window.addEventListener("resize", this.handleWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
};
